// src/components/ApprovePOButton.jsx
import React, { useState } from "react";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

export default function ApprovePOButton({ poId, onApproved }) {
  const [loading, setLoading] = useState(false);
  const handleApprove = async () => {
    if (!poId) return;
    setLoading(true);
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) { alert("Login required"); setLoading(false); return; }

      const functions = getFunctions();
      const approve = httpsCallable(functions, "approvePO");
      const resp = await approve({ poId });
      const data = resp.data;
      if (data?.ok) {
        alert(`PO Approved: ${data.poNo}`);
        onApproved && onApproved(data);
      } else {
        alert("Approve failed: " + JSON.stringify(data));
      }
    } catch (err) {
      console.error("approve error", err);
      alert("Approve failed: " + (err?.message || String(err)));
    } finally { setLoading(false); }
  };

  return (
    <button onClick={handleApprove} disabled={loading} className="px-2 py-1 bg-green-600 text-white rounded">
      {loading ? "Approving..." : "Approve"}
    </button>
  );
}
